import React from 'react';

function ResetPosition({
  node,
  customPositions,
  setCustomPositions,
  handleClose,
  onHistoryCheckpoint = null
}) {
  React.useEffect(() => {
    // UNDO checkpoint only when there is actually a pin to clear: this menu item
    // mounts (and fires) unconditionally, and a no-pin "clear" is a content no-op
    // that must not create an undo step. customPositions here is fresh — the
    // ContextMenu memo re-renders on every customPositions change.
    if (
      onHistoryCheckpoint &&
      customPositions instanceof Map &&
      customPositions.has(node.uid)
    ) {
      onHistoryCheckpoint();
    }
    const next = new Map(customPositions);
    next.delete(node.uid);
    setCustomPositions(next);
    handleClose();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}

export default ResetPosition;
